import React, { useEffect } from "react";
import SpinnerComponent from "../../../../Components/Loding/Spinner";
import { ListarProdutosEmAtendimentoDeFilaController } from "../../../../Controllers/Cobranca/FilaAtendimento/FilaAtendimentoController";
import useArrayState from "../../../../hooks/useArrayState";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { useTransformToRef } from "../../../../hooks/useTransformToRef";

interface ISeletorMultiCasoContatoProps {
    onChange: (ID_CASOs: Array<number>) => void;
    ID_CASO: number;
}
/*
const mock = [{
    ID_CASO: 25,
    ID_PRODUTO: 399,
    DS_EMPREENDIMENTO: "Jardim Europa",
    DS_UNIDADE: "Quadra 06 Lote 32",
    ID_CHAVE_ERP: "43_UFRG_5463",
},{
    ID_CASO: 26,
    ID_PRODUTO: 450,
    DS_EMPREENDIMENTO: "Jardim Europa",
    DS_UNIDADE: "Quadra 06 Lote 31",
    ID_CHAVE_ERP: "43_UFRG_5462",
},{
    ID_CASO: 27,
    ID_PRODUTO: 459,
    DS_EMPREENDIMENTO: "Porto de Galinhas",
    DS_UNIDADE: "Quadra 01 Lote 01",
    ID_CHAVE_ERP: "43_UFRR_1125",
},{
    ID_CASO: 28,
    ID_PRODUTO: 490,
    DS_EMPREENDIMENTO: "Porto de Galinhas",
    DS_UNIDADE: "Quadra 06 Lote 31",
    ID_CHAVE_ERP: "43_UFRR_1100",
}]*/

export function SeletorMultiCasoContato(props: ISeletorMultiCasoContatoProps) {
    const [checkeds, setCheckeds] = useArrayState<number>();

    const onChangeRef = useTransformToRef(props.onChange);

    const { value: lstProdutosCaso, loading } = useAsyncEffect(() => {
        return ListarProdutosEmAtendimentoDeFilaController(props.ID_CASO);
    }, [props.ID_CASO]);

    useEffect(() => {
        onChangeRef.current(checkeds);
    }, [checkeds, onChangeRef]);

    return (
        <>
            {loading ? (
                <SpinnerComponent />
            ) : (
                lstProdutosCaso &&
                lstProdutosCaso?.length > 0 && (
                    <div className="my-4">
                        <strong>
                            Replicar contato para outros atendimentos do
                            cliente:
                        </strong>
                        <div className="d-flex align-items-center justify-content-start g-2 mt-2">
                            <input
                                type="checkbox"
                                id="marcarTodosChecks"
                                onChange={(e) => {
                                    if (e.target.checked)
                                        setCheckeds.reset(
                                            lstProdutosCaso?.map(
                                                (pc) => pc.ID_CASO
                                            )
                                        );
                                    else setCheckeds.reset();
                                }}
                                checked={
                                    checkeds.length === lstProdutosCaso?.length
                                }
                            />
                            <label htmlFor="marcarTodosChecks" className="m-0">
                                Marcar todos
                            </label>
                        </div>

                        <div className="d-flex align-items-scratch justify-content-start g-5 mw-100 x-scroll">
                            {lstProdutosCaso?.map((produtoCaso) => (
                                <label
                                    className="d-flex align-items-center justify-content-center border p-5"
                                    role="button"
                                    key={produtoCaso.ID_CASO}
                                >
                                    <input
                                        type="checkbox"
                                        className="mr-5"
                                        checked={checkeds.some(
                                            (ID_CASO) =>
                                                ID_CASO === produtoCaso.ID_CASO
                                        )}
                                        onChange={(e) => {
                                            if (e.target.checked)
                                                setCheckeds.add(
                                                    produtoCaso.ID_CASO
                                                );
                                            else
                                                setCheckeds.remove(
                                                    produtoCaso.ID_CASO
                                                );
                                        }}
                                    />
                                    <div>
                                        <strong className="ws-nowrap">
                                            {produtoCaso.DS_EMPREENDIMENTO}
                                        </strong>
                                        <div className="ws-nowrap">
                                            {produtoCaso.DS_UNIDADE}
                                        </div>
                                        <div className="ws-nowrap text-muted">
                                            {produtoCaso.ID_CHAVE_ERP}
                                        </div>
                                    </div>
                                </label>
                            ))}
                        </div>
                    </div>
                )
            )}
        </>
    );
}
